// extracted by mini-css-extract-plugin
module.exports = {"dark":"Granulate_dark__2lRNC","imageHolder":"Granulate_imageHolder__o5XUP","textContainer":"Granulate_textContainer__3zdxM"};